<template>
  <div class="categories-container">
    <base-loader v-if="dataIsLoading" />
    <div v-else class="categories-block">
      <base-nav
        title="Категории расходов"
        :show-back="true"
        :back-handler="goToExpenses"
      >
        <base-primary-button
          icon="addSquare"
          class="nav-btn"
          @click="isAddCategoryModalVisible = true"
        >
          Создать
        </base-primary-button>
      </base-nav>
      <ul class="categories-list">
        <li
          class="card categories-item"
          :class="{ 'item-disabled': !category.enabled }"
          v-for="category in expenseCategories"
          :key="category.id"
          @click="
            (getCategoryId = category.id),
              (isEditCategoryModalVisible = true)
          "
        >
          <div class="item-left">
            <span class="category-emoji">{{ category.emoji }}</span>
            {{ category.name }}
          </div>
          <div class="item-right">
            <div class="item-right-box" @click.stop>
              <base-toggle-switch
                :model-value="category.enabled"
                @update:model-value="toggleCategory(category)"
                :disabled="loading"
              />
            </div>
          </div>
        </li>
      </ul>

      <!-- Пагинация -->
      <pagination-component
        v-if="!dataIsLoading && pagination.pages > 1"
        :page="pagination.page"
        :pages="pagination.pages"
        :series="pagination.series"
      />
    </div>
    <add-category-modal
      v-if="isAddCategoryModalVisible"
      :company-id="companyId"
      @close="isAddCategoryModalVisible = false"
      @categories-created="createSuccess"
    />

    <edit-category-modal
      v-if="isEditCategoryModalVisible"
      :company-id="companyId"
      :category-id="getCategoryId"
      @close="isEditCategoryModalVisible = false"
      @categories-updated="updateSuccess"
    />
  </div>
</template>

<script>
import AddCategoryModal from "@/components/AddCategoryModal";
import EditCategoryModal from "@/components/EditCategoryModal.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";

import expenseCategoriesApi from "@/services/api/expenseCategoriesApi";

import { getCompanyId } from "@/utils/userUtils";
import { useNotificationStore } from "@/stores/notificationStore";

export default {
  name: "ExpenseCategoriesPage",
  components: {
    AddCategoryModal,
    EditCategoryModal,
    PaginationComponent,
  },
  data() {
    return {
      expenseCategories: [],
      companyId: getCompanyId(),
      dataIsLoading: true,
      loading: false,

      isAddCategoryModalVisible: false,
      isEditCategoryModalVisible: false,
      getCategoryId: null,

      pagination: {
        page: 1,
        pages: 1,
        series: [],
        next: null,
        prev: null,
        count: 0,
        limit: 40,
      },
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },
  watch: {
    "$route.query.page": {
      immediate: false,
      handler(newPage) {
        this.getExpenseCategories(newPage);
      },
    },
  },
  methods: {
    async getExpenseCategories(page) {
      const pageNumber =
        parseInt(page) || parseInt(this.$route.query.page) || 1;

      try {
        this.dataIsLoading = true;

        const response = await expenseCategoriesApi.index(
          this.companyId,
          {
            page: pageNumber,
          }
        );

        this.expenseCategories = response.data.result;

        const meta = response.data.pagination_meta;
        this.pagination = {
          page: meta.page,
          pages: meta.pages,
          series: meta.series,
          next: meta.next,
          prev: meta.prev,
          count: meta.count,
          limit: meta.limit,
        };

        if (this.$route.query.page != String(pageNumber)) {
          this.$router
            .replace({
              query: { ...this.$route.query, page: pageNumber },
            })
            .catch(() => {});
        }
      } finally {
        this.dataIsLoading = false;
      }
    },

    async toggleCategory(category) {
      this.loading = true;

      try {
        const response = await expenseCategoriesApi.toggle(
          this.companyId,
          category.id
        );

        if (response.data.result.enabled) {
          this.notificationStore.showSuccess("Категория включена");
        } else {
          this.notificationStore.showSuccess("Категория отключена");
        }

        this.updateSuccess(response.data.result);
      } finally {
        this.loading = false;
      }
    },

    createSuccess() {
      this.getExpenseCategories();
    },

    updateSuccess(editedCategory) {
      let targetCategory = this.expenseCategories.find(
        (cat) => cat.id === editedCategory.id
      );

      if (targetCategory) {
        Object.keys(targetCategory).forEach(
          (key) => delete targetCategory[key]
        );
        Object.assign(targetCategory, editedCategory);
      }
    },

    goToExpenses() {
      const previous = this.$router.options.history.state?.back;

      if (previous && previous.includes("/expenses")) {
        this.$router.push({ name: "Expenses" });
        return;
      }

      this.$router.back();
    },
  },
  async created() {
    await this.getExpenseCategories(this.$route.query.page);
  },
};
</script>

<style scoped>
.categories-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 15px;
}

.categories-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.categories-item:not(.item-disabled):hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.item-disabled {
  background-color: rgba(186, 186, 186, 0.35);
}

.item-right {
  display: flex;
  gap: 30px;
}

.item-edit-btn {
  cursor: pointer;
}
</style>
